import React, { useRef } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/oralbook/EditSectionRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.oralbook.editsection;

class EditSectionScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_SECTION_ASYNC]: { done: this._handleSaveSectionAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id, courseId } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.createSection(courseId);
    }

    render() {
        const { section } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!section || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    section={section}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSaveSection}
                                    localVars={this.localVars.navParams}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_SECTION_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSaveSection = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        this.props.saveSectionAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveSectionAsyncDone = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { section, localVars } = props;
    const { id, courseId, title } = section;
    const { register, handleSubmit, errors } = useForm();
    const submitRef = useRef();
    const { index, sectionType } = localVars;
    const num = index + 1;
    const type = sectionType === 0 ? props.t("chapter") : sectionType === 1 ? props.t("lesson") : sectionType === 2 ? props.t("section") : "";

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{localVars.id ? props.t("editsection") : props.t("addsection")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <input name="courseId" hidden type="text" className="form-control" defaultValue={courseId} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("no.")}</label>
                                    <input name="order" disabled type="text" className="form-control-alternative form-control" defaultValue={props.t("sectionNo", { num, type })} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("title")}</label>
                                    <input name="title" type="text" className="form-control-alternative form-control" defaultValue={title} maxLength={100}
                                        ref={register({ required: true })} />
                                    {errors.title && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveSectionAsync: vo => dispatch(Actions.saveSectionAsync(vo)),
        createSection: (courseId) => dispatch(Actions.createSection(courseId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditSectionScreen));